import { createSelector, ParametricSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

type isLoadingKeyType = 'isFetchSitesManagementDashboard' | 'isRedeployAllLandings'

const getIsLoadingSelectorByKey: ParametricSelector<ReduxState, isLoadingKeyType, boolean> = (state, isLoadingKey) =>
  state.sitesManagement.UIState[isLoadingKey] || false

export const isLoadingSelector = createSelector(getIsLoadingSelectorByKey, isLoading => isLoading)
